import React, { useContext } from "react";
import styled from "styled-components";

import UnitCanvasDisplay from "./UnitCanvasDisplay";
import SeasonalFlavor from "./../../common/SeasonalFlavor";

import { UnitContext } from "./../UnitContextWrapper";

const UnitCanvasWrapper = styled.div`
    position: relative;
    text-align: center;
    display: block;
    left: 0;
    top: 0;
    width: ${props => props.theme.tabletCutoffWidth + 1}px;
    max-width: ${props => props.theme.tabletCutoffWidth + 1}px;
    z-index: 15;

    @media print {
        display: none;
    }

    @media only screen and (max-width: ${props => props.theme.tabletCutoffWidth}px) {
        display: none;
    }
`;

UnitCanvasWrapper.displayName = "UnitCanvasWrapper";

function UnitCanvasContainer() {
    const { unitsSelected } = useContext(UnitContext);

    const unitsEl = unitsSelected
        .map((unit, index) => {
            if (unit.id !== "empty") {
                return (
                    <UnitCanvasDisplay
                        key={`unit-${unit.id}`}
                        index={index}
                        unit={unit}
                    />
                );
            }

            return null;
        });

    return (
        <UnitCanvasWrapper>
            <SeasonalFlavor />
            {unitsEl}
        </UnitCanvasWrapper>
    );
}

export default UnitCanvasContainer;
